<script lang="ts" setup>
import { ContactHealthScoreModel } from '@/types';
import { getContactHealthScoreTrend } from '@/utils/contactHealthScore';
import ActivityIcon from '@/assets/icons/activity.svg';
import { computed } from 'vue';

interface Props {
    healthScore: ContactHealthScoreModel;
}

const props = defineProps<Props>();
const status = computed(() => {
    if (props.healthScore?.trend == null) return null;
    return getContactHealthScoreTrend(props.healthScore?.trend);
});
const scoreColor = (score: number) => {
    if (score >= 70) return 'bg-success-200 text-success-700';
    if (score >= 30) return 'bg-warning-200 text-warning-800';
    return 'bg-danger-200 text-danger';
};
</script>
<template>
    <div
        v-if="healthScore.score !== null"
        class="inline-flex items-center gap-2 rounded-full px-2 py-1 text-xs font-semibold"
        :class="scoreColor(healthScore.score)"
        title="Health score do relacionamento"
    >
        <img :src="ActivityIcon" class="mr-0 h-3 w-3" />
        <span class="mr-0.5 font-mono">{{ healthScore.score }}</span>
        {{ status ? $t('contact.timeline.stats.healthScore.' + status) : '-' }}
    </div>
</template>
